// CheckyPro redirect integration, source retrieved 2026-11-04.
// KLAIM adaptation: the four final navigation calls preserve accepted Shopify codes.
(function () {
    // Configuration constants
    const CONFIG = {
        CACHE_TIMEOUT_MS: 60000, // 1 minute cache
        POLL_INTERVAL_MS: 3000, // 3 seconds between polling requests
        TOKEN_CHECK_INTERVAL_MS: 3000, // Check for cart token every 3 seconds
        BASE_URL: "https://app.checkypro.com",
        CHECKOUT_URL: "https://checkout.klaimamsterdam.com/checkout-redirect",
        CHECKOUT_SELECTOR:
            '.easc-checkoutBtn, [name="checkout"], [name="Checkout"], [class*="opcCheckout"], [class*="kodrite_p24"], [class*="checkout-btn"], [class*="btn-checkout"], [class*="checkout-button"], [class*="button-checkout"], [class*="carthook_checkout"], [type*="submit"][class*="action_button"]:not([name*="add"]), [href*="/checkout"][class*="action_button"], [id*="checkout"], [id*="Checkout"], [id*="checkout-button"], [id*="checkout-btn"], [sc*="checkout"], [sc*="Checkout"], [class*="shopify-payment-button__more-options"], [class*="shopify-payment-button__button--unbranded"], [onclick*="/checkout"], shopify-buy-it-now-button button:not([aria-disabled="true"])',
        DYNAMIC_PAYMENT_SELECTOR:
            '[data-shopify="payment-button"] button:not([aria-disabled="true"]), [data-shopify="payment-button"] .shopify-payment-button__button:not([aria-disabled="true"]), shopify-buy-it-now-button button:not([aria-disabled="true"])',
    };

    // Get the validation URL using the checkout URL domain
    function getValidationUrl() {
        try {
            const checkoutUrl = new URL(CONFIG.CHECKOUT_URL);
            return `${checkoutUrl.protocol}//${checkoutUrl.host}/validate/cart-session`;
        } catch (error) {
            console.error("Error parsing checkout URL:", error);
            // Fallback to relative URL
            return "/validate/cart-session";
        }
    }

    function getTrackSessionUrl() {
        if (!CONFIG.BASE_URL) return null;
        const base = String(CONFIG.BASE_URL).trim();
        return (base.endsWith("/") ? base : base + "/") + "track-session";
    }

    // Derive the storefront URL from Shopify.cdnHost (strip /cdn, add https)
    function getStorefrontUrlFromCdn() {
        const cdnHost = window.Shopify?.cdnHost;
        if (!cdnHost) return null;

        let base = String(cdnHost).replace(/\/cdn\/?$/i, "").trim();
        if (!base) return null;

        if (!/^https?:\/\//i.test(base)) {
            base = "https://" + base;
        }

        return base.endsWith("/") ? base : base + "/";
    }

    function trackSession() {
        const SESSION_KEY = "checkypro_session_tracked";
        const SESSION_EXPIRY_KEY = "checkypro_session_expiry";
        const LOCK_KEY = "checkypro_session_lock";       // NEW: cross-tab lock
        const LOCK_DURATION_MS = 5000;                   // 5s window to prevent races
        const SESSION_DURATION_MS = 30 * 60 * 1000;

        try {
            const now = Date.now();

            // Check if already tracked and still valid
            const expiry = parseInt(localStorage.getItem(SESSION_EXPIRY_KEY) || "0", 10);
            if (localStorage.getItem(SESSION_KEY) === "1" && expiry > now) {
                return;
            }

            // Cross-tab lock: if another tab grabbed the lock recently, bail out
            const lockExpiry = parseInt(localStorage.getItem(LOCK_KEY) || "0", 10);
            if (lockExpiry > now) {
                return;
            }

            // Grab the lock before firing the request
            localStorage.setItem(LOCK_KEY, (now + LOCK_DURATION_MS).toString());

            const domain = getStoreName();
            if (!domain) return;

            const storefrontUrl = getStorefrontUrlFromCdn();
            const domainToSend = storefrontUrl || domain;

            const url = getTrackSessionUrl();
            if (!url) return;

            fetch(url, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ domain: domainToSend }),
                credentials: "omit",
            })
                .then(function (res) {
                    if (res && res.ok) {
                        localStorage.setItem(SESSION_KEY, "1");
                        localStorage.setItem(
                            SESSION_EXPIRY_KEY,
                            (Date.now() + SESSION_DURATION_MS).toString()
                        );
                    }
                    // Release lock either way
                    localStorage.removeItem(LOCK_KEY);
                })
                .catch(function () {
                    // Release lock on error too so it doesn't stay stuck
                    localStorage.removeItem(LOCK_KEY);
                });
        } catch (e) { }
    }

    // State management
    const state = {
        lastCheckoutUrl: null,
        isInitialized: false,
        tokenCheckInterval: null,
    };

    // Helper functions to retrieve parameters
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(";").shift();
    }

    function getUrlParameter(name) {
        const params = new URLSearchParams(window.location.search);
        return params.get(name);
    }

    function getLocalStorageItem(name) {
        try {
            return localStorage.getItem(name);
        } catch (e) {
            // LocalStorage might not be available in some contexts
            return null;
        }
    }

    // Get cart token directly from cookie (includes key parameter)
    function getCartToken() {
        const token = getCookie("cart");
        // Decode the URL-encoded cookie value
        return token ? decodeURIComponent(token) : null;
    }

    function getStoreName() {
        return window.Shopify?.shop || "";
    }

    function getLanguage() {
        return window.Shopify?.locale || "en";
    }

    // Get cart details from cookie (no fetch needed!)
    function getCartDetails() {
        const token = getCartToken();
        const shopifyUrl = getStoreName();
        const language = getLanguage();

        if (!token) {
            return null;
        }

        if (!shopifyUrl) {
            console.error("Store name not found");
            return null;
        }

        return {
            shopifyUrl,
            token,
            language,
        };
    }

    // Parse cart cookie to extract token and key
    function parseCartCookie() {
        const cartCookie = getCookie("cart");
        if (!cartCookie) {
            return null;
        }

        // Decode the URL-encoded cookie value
        const decodedValue = decodeURIComponent(cartCookie);

        // Split by "?key=" to separate token and key
        const [cartToken, cartKey] = decodedValue.split("?key=");

        if (!cartToken || !cartKey) {
            console.warn("Invalid cart cookie format:", decodedValue);
            return null;
        }

        return {
            cart_token: cartToken,
            cart_key: cartKey
        };
    }

    // Validate cart session with backend
    async function validateCartSession() {
        const cartData = parseCartCookie();
        if (!cartData) {
            //console.log("No valid cart cookie found for validation");
            return { allow_delete: false, reason: 'no_cart_cookie' };
        }

        try {
            // Create URL with query parameters using the checkout URL domain
            const validationUrl = getValidationUrl();
            const url = new URL(validationUrl);
            url.searchParams.append('cart_token', cartData.cart_token);
            url.searchParams.append('cart_key', cartData.cart_key);

            const response = await fetch(url.toString(), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin'
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            //console.log("Cart session validation result:", result);
            return result;
        } catch (error) {
            console.error("Error validating cart session:", error);
            return { allow_delete: false, reason: 'validation_error' };
        }
    }

    // Check if cart cookie should be deleted based on validation
    async function checkCartCookieDeletion() {
        const validation = await validateCartSession();

        if (validation.allow_delete) {
            //console.log(`Cart cookie can be deleted. Reason: ${validation.reason}`);
            // Delete the cart cookie
            document.cookie = "cart=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            return true;
        } else {
            //console.log(`Cart cookie should be kept. Reason: ${validation.reason}`);
            return false;
        }
    }

    // Collect all tracking parameters from URL and cookies
    function collectTrackingParameters() {
        const fbclid = getUrlParameter("fbclid") || getCookie("fbclid");

        return {
            fbclid,
            fbp: getCookie("_fbp"),
            fbc:
                getCookie("_fbc") || (fbclid ? `fb.1.${Date.now()}.${fbclid}` : null),
            ttclid: getUrlParameter("ttclid"),
            ttp: getCookie("_ttp"),
            shopifySaP: getCookie("_shopify_sa_p"),
            utmSource: getUrlParameter("utm_source"),
            utmMedium: getUrlParameter("utm_medium"),
            utmCampaign: getUrlParameter("utm_campaign"),
            utmContent: getUrlParameter("utm_content"),
            utmTerm: getUrlParameter("utm_term"),
            utmLang: window.navigator.languages
                ? window.navigator.languages[0]
                : null,
            utmIplang: window.Shopify?.locale,
            tbId: getLocalStorageItem("_tb_id"),
            tbIdTimestamp: getLocalStorageItem("_tb_id_timestamp"),
        };
    }

    // Function to construct the new checkout URL with parameters
    function constructCheckoutUrl({ shopifyUrl, token, language }) {
        const [tokenPart, keyPart] = token.split("?key=");
        let checkoutUrl = `${CONFIG.CHECKOUT_URL}/${shopifyUrl}`;

        // Collecting tracking parameters
        const trackingParams = collectTrackingParameters();

        // Add query parameters to the checkout URL
        const params = new URLSearchParams();
        params.append("token", tokenPart);

        // Key should always exist in cookie, but check just in case
        if (keyPart && keyPart !== "undefined") {
            params.append("key", keyPart);
        } else {
            console.warn("Key parameter missing from cart token:", token);
        }

        params.append("language", language);

        if (trackingParams.fbclid) params.append("fbclid", trackingParams.fbclid);
        if (trackingParams.fbp) params.append("_fbp", trackingParams.fbp);
        if (trackingParams.fbc) params.append("_fbc", trackingParams.fbc);
        if (trackingParams.ttclid) params.append("ttclid", trackingParams.ttclid);
        if (trackingParams.ttp) params.append("_ttp", trackingParams.ttp);
        if (trackingParams.shopifySaP)
            params.append("_shopify_sa_p", trackingParams.shopifySaP);
        if (trackingParams.utmSource)
            params.append("utm_source", trackingParams.utmSource);
        if (trackingParams.utmMedium)
            params.append("utm_medium", trackingParams.utmMedium);
        if (trackingParams.utmCampaign)
            params.append("utm_campaign", trackingParams.utmCampaign);
        if (trackingParams.utmContent)
            params.append("utm_content", trackingParams.utmContent);
        if (trackingParams.utmTerm)
            params.append("utm_term", trackingParams.utmTerm);
        if (trackingParams.utmLang)
            params.append("utm_lang", trackingParams.utmLang);
        if (trackingParams.utmIplang)
            params.append("utm_iplang", trackingParams.utmIplang);
        if (trackingParams.tbId)
            params.append("_tb_id", trackingParams.tbId);
        if (trackingParams.tbIdTimestamp)
            params.append("_tb_id_timestamp", trackingParams.tbIdTimestamp);

        const paramString = params.toString();
        if (paramString) {
            checkoutUrl += `?${paramString}`;
        }

        return checkoutUrl;
    }

    // Button manager for consistent handling
    const ButtonManager = {
        getCheckoutButtons() {
            return document.querySelectorAll(CONFIG.CHECKOUT_SELECTOR);
        },

        getDynamicPaymentButtons() {
            return document.querySelectorAll(CONFIG.DYNAMIC_PAYMENT_SELECTOR);
        },

        updateAllButtons(newCheckoutUrl) {
            const checkoutButtons = this.getCheckoutButtons();

            console.log("[CheckyPro ButtonManager] Updating buttons:", {
                count: checkoutButtons.length,
                url: newCheckoutUrl
            });

            // Parse URL to separate base URL and query parameters
            const urlParts = newCheckoutUrl.split("?");
            const baseUrl = urlParts[0];
            const queryString = urlParts[1] || "";
            const params = new URLSearchParams(queryString);

            checkoutButtons.forEach((button, index) => {
                console.log(`[CheckyPro ButtonManager] Processing button ${index + 1}:`, {
                    tagName: button.tagName,
                    className: button.className,
                    id: button.id,
                    name: button.name
                });
                resetCheckoutButtonState(button);

                if (button.tagName === "A") {
                    button.href = newCheckoutUrl;
                } else if (button.tagName === "BUTTON") {
                    const form = button.closest("form");
                    if (form) {
                        form.action = baseUrl;
                        form.method = "GET";

                        // Remove any existing hidden inputs added by CheckyPro
                        const existingInputs = form.querySelectorAll(
                            "input[data-checkypro-param]"
                        );
                        existingInputs.forEach((input) => input.remove());

                        // Add hidden inputs for each query parameter
                        params.forEach((value, key) => {
                            const input = document.createElement("input");
                            input.type = "hidden";
                            input.name = key;
                            input.value = value;
                            input.setAttribute("data-checkypro-param", "true");
                            form.appendChild(input);
                        });

                        // Add form submit handler to get fresh cart details from cookie
                        if (!form.dataset.checkyProFormHandled) {
                            form.dataset.checkyProFormHandled = "true";
                            form.addEventListener("submit", (e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                // Get latest cart details from cookie (no fetch!)
                                const cartDetails = getCartDetails();
                                if (cartDetails && cartDetails.token) {
                                    const checkoutUrl = constructCheckoutUrl(cartDetails);
                                    //console.log(
                                    //     "Form submit: Redirecting with latest URL:",
                                    //     checkoutUrl
                                    // );
                                    navigateToChecky(checkoutUrl);
                                }
                                return false;
                            });
                        }
                    }

                    // Add event listeners for the button
                    addButtonEventListeners(button);
                }
            });
        },
    };

    function resetCheckoutButtonState(button) {
        if (!button || button.nodeType !== 1) return;
        button.disabled = false;
        button.style.pointerEvents = '';
        button.style.opacity = '';
        button.style.cursor = '';
    }

    function disableCheckoutButton(button) {
        if (!button || button.nodeType !== 1) return;
        button.disabled = true;
        button.style.pointerEvents = 'none';
        button.style.opacity = '0.6';
        button.style.cursor = 'wait';
    }

    // Preserve the Shopify-accepted discount codes before the final provider handoff.
    function navigateToChecky(checkoutUrl) {
        if (!window.KlaimCheckyDiscounts) {
            isProcessingBuyNow = false;
            resetAllCheckoutButtons();
            alert('Checkout could not load your discount. Please refresh and try again.');
            return;
        }
        window.KlaimCheckyDiscounts.redirect(checkoutUrl).catch(function (error) {
            isProcessingBuyNow = false;
            resetAllCheckoutButtons();
            alert(error.message || 'Checkout could not preserve your discount. Please try again.');
        });
    }

    function resetAllCheckoutButtons() {
        ButtonManager.getCheckoutButtons().forEach(resetCheckoutButtonState);
        ButtonManager.getDynamicPaymentButtons().forEach(resetCheckoutButtonState);
        var root = window.upcartDocumentOrShadowRoot;
        if (root) {
            root.querySelectorAll('.upcart-checkout-button, .checkypro-custom-checkout-button')
                .forEach(resetCheckoutButtonState);
        }
    }

    // Event handling helpers
    function preventDefaultAction(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    function redirectToCheckout(event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }

        // Get the latest cart details from cookie (no fetch needed!)
        const cartDetails = getCartDetails();

        if (cartDetails && cartDetails.token) {
            const checkoutUrl = constructCheckoutUrl(cartDetails);
            navigateToChecky(checkoutUrl);
        } else {
            console.error("Failed to get cart details for checkout");
            alert("Please add items to your cart before checking out.");
        }
        return false;
    }

    function addButtonEventListeners(button) {
        // Check if this is actually a checkout button and not an add to cart button
        if (!button.matches(CONFIG.CHECKOUT_SELECTOR)) {
            return;
        }

        // Only attach once
        if (button.dataset.checkyProAttached) {
            return;
        }

        // Add secure event listeners
        ["click", "mousedown", "touchstart"].forEach((eventType) => {
            button.addEventListener(eventType, (e) => redirectToCheckout(e), true);
        });

        button.dataset.checkyProAttached = "true";
    }

    // Handle "More payment options" links
    function handleMorePaymentOptionsLinks(newCheckoutUrl) {
        const moreOptionsLinkContainers = document.getElementsByTagName(
            "more-payment-options-link"
        );

        for (const linkContainer of moreOptionsLinkContainers) {
            const moreOptionsLink = linkContainer.querySelector(
                "#more-payment-options-link"
            );
            if (moreOptionsLink) {
                moreOptionsLink.href = newCheckoutUrl;
                // Attach once so bfcache restore / re-wire does not stack listeners
                if (linkContainer.dataset.checkyProMoreOptionsHandled) {
                    continue;
                }
                linkContainer.dataset.checkyProMoreOptionsHandled = "true";
                linkContainer.addEventListener("click", (e) => {
                    e.preventDefault();
                    redirectToCheckout(e);
                });
            }
        }
    }

    // Flag to prevent concurrent executions of addToCartAndRedirect
    let isProcessingBuyNow = false;

    // Function to add to cart and redirect to checkout
    async function addToCartAndRedirect(button) {
        // Prevent concurrent executions
        if (isProcessingBuyNow) {
            return;
        }

        isProcessingBuyNow = true;

        try {
            // Disable the button immediately to prevent multiple clicks
            disableCheckoutButton(button);
            // Try to find the product form in multiple ways
            let form = button.closest('form[action*="/cart/add"]');

            // If form not found directly, try to find any product form on the page
            if (!form) {
                form = document.querySelector('form[action*="/cart/add"]');
            }

            if (!form) {
                console.error("No product form found");
                isProcessingBuyNow = false;
                resetCheckoutButtonState(button);
                return;
            }

            // Find the variant ID
            const variantInput = form.querySelector('input[name="id"]');
            if (!variantInput) {
                console.error("No variant ID found");
                isProcessingBuyNow = false;
                resetCheckoutButtonState(button);
                return;
            }

            const variantId = variantInput.value;
            const formId = form.getAttribute('id');

            let quantityInput = form.querySelector('input[name="quantity"]');

            if (!quantityInput) {
                quantityInput = form.querySelector(".quantity__input");
            }
            if (!quantityInput) {
                quantityInput = form.querySelector('input[type="number"][name="quantity"]');
            }

            if (!quantityInput && formId) {
                quantityInput = document.querySelector(`input[name="quantity"][form="${formId}"]`);

                if (!quantityInput) {
                    quantityInput = document.querySelector(`.quantity__input[form="${formId}"]`);
                }

                if (!quantityInput) {
                    quantityInput = document.querySelector(`input[type="number"][form="${formId}"]`);
                }
            }

            if (!quantityInput) {
                const container = button.closest('.product-form, .product, [class*="product"], main, .main-content');
                if (container) {
                    quantityInput = container.querySelector('.quantity__input');

                    if (!quantityInput) {
                        quantityInput = container.querySelector('input[name="quantity"]');
                    }

                    if (!quantityInput) {
                        quantityInput = container.querySelector('input[type="number"][name="quantity"]');
                    }
                }
            }

            if (!quantityInput) {
                const container = form.closest('.product-form, .product, [class*="product"], main, .main-content');
                if (container) {
                    quantityInput = container.querySelector('.quantity__input');

                    if (!quantityInput) {
                        quantityInput = container.querySelector('input[name="quantity"]');
                    }
                }
            }

            if (!quantityInput) {
                quantityInput = document.querySelector('.quantity__input');

                if (!quantityInput) {
                    quantityInput = document.querySelector('input[name="quantity"]');
                }
            }

            const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

            // Clear the cart first
            const clearResponse = await fetch("/cart/clear.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (!clearResponse.ok) {
                throw new Error("Failed to clear cart");
            }

            await clearResponse.json();

            // Add to cart using Shopify AJAX API
            const response = await fetch("/cart/add.js", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    items: [
                        {
                            id: variantId,
                            quantity: quantity,
                        },
                    ],
                }),
            });

            if (!response.ok) {
                throw new Error("Failed to add to cart");
            }

            // Wait for the cart addition to complete
            await response.json();

            // Wait a bit for cart cookie to be updated (critical!)
            await new Promise(resolve => setTimeout(resolve, 500));

            // Cart cookie is now updated, redirect to checkout
            isProcessingBuyNow = false; // Reset flag before redirect
            redirectToCheckout();
        } catch (error) {
            console.error("Error managing cart:", error);
            isProcessingBuyNow = false; // Reset flag on error
            resetCheckoutButtonState(button);
        }
    }

    // Function to handle checkout button logic
    function handleCheckoutProcess() {
        //console.log("[CheckyPro handleCheckoutProcess] Called");

        // Get cart details from cookie (no fetch!)
        const cartDetails = getCartDetails();

        //console.log("[CheckyPro handleCheckoutProcess] Cart details:", cartDetails);

        if (!cartDetails?.token) {
            //console.log("[CheckyPro handleCheckoutProcess] No token found, returning null");
            return null;
        }

        // Construct checkout URL
        const newCheckoutUrl = constructCheckoutUrl(cartDetails);

        //console.log("[CheckyPro handleCheckoutProcess] Constructed URL:", newCheckoutUrl);
        //console.log("[CheckyPro handleCheckoutProcess] Last URL:", state.lastCheckoutUrl);

        // Only update buttons if URL has changed
        if (newCheckoutUrl !== state.lastCheckoutUrl) {
            //console.log("[CheckyPro handleCheckoutProcess] URL changed, updating buttons...");

            // Update all checkout buttons
            ButtonManager.updateAllButtons(newCheckoutUrl);

            // Handle "More payment options" links
            handleMorePaymentOptionsLinks(newCheckoutUrl);

            // Store the last checkout URL
            state.lastCheckoutUrl = newCheckoutUrl;
        }

        return newCheckoutUrl;
    }

    // Function to set up a dynamic payment button
    function setupDynamicButton(button, checkoutUrl) {
        if (button.dataset.checkyProHandled) return;

        // Mark as handled
        button.dataset.checkyProHandled = "true";

        // Temporarily disable the button
        const wasDisabled = button.disabled;
        button.disabled = true;

        // Create a new button to replace the old one
        const newButton = button.cloneNode(true);
        newButton.disabled = wasDisabled;
        newButton.dataset.checkyProHandled = "true";

        // Add our click handler to the new button
        newButton.addEventListener(
            "click",
            async (e) => {
                // Check if already processing
                if (isProcessingBuyNow) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    return false;
                }

                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                try {
                    await addToCartAndRedirect(newButton);
                } catch (error) {
                    console.error("Failed to process checkout:", error);
                }
                return false;
            },
            true
        );

        // Replace the old button with the new one
        button.parentNode.replaceChild(newButton, button);
    }

    // Function to enable checkout buttons after initialization
    function enableCheckoutButtons() {
        if (document.body) {
            document.body.classList.add('checkypro-ready');
            //console.log("[CheckyPro] Checkout buttons enabled \u2713");
        } else {
            // If body doesn't exist yet, wait for DOM
            document.addEventListener('DOMContentLoaded', () => {
                document.body.classList.add('checkypro-ready');
                //console.log("[CheckyPro] Checkout buttons enabled \u2713");
            });
        }
    }

    // Function to check for cart token periodically
    function startTokenPolling() {
        //console.log("CheckyPro: Waiting for cart token... (will keep checking indefinitely)");

        state.tokenCheckInterval = setInterval(() => {
            // Try to get cart details
            const cartDetails = getCartDetails();

            if (cartDetails?.token) {
                // Token found! Stop polling and complete initialization
                //console.log("CheckyPro: Cart token found! Completing initialization...");
                clearInterval(state.tokenCheckInterval);
                state.tokenCheckInterval = null;
                completeInitialization();
            }
        }, CONFIG.TOKEN_CHECK_INTERVAL_MS);
    }

    // Complete initialization once token is available
    function completeInitialization() {
        if (state.isInitialized) {
            //console.log("[CheckyPro completeInitialization] Already initialized, skipping");
            return;
        }

        //console.log("[CheckyPro completeInitialization] Starting initialization...");
        state.isInitialized = true;

        // Enable checkout buttons now that script is ready
        enableCheckoutButtons();

        // Validate cart session on initialization
        checkCartCookieDeletion().then((wasDeleted) => {
            if (wasDeleted) {
                //console.log("Cart cookie was deleted during validation");
                // Optionally refresh or handle the deletion
            }
        }).catch((error) => {
            console.error("Error during cart validation:", error);
        });

        // Initial process to get checkout URL from cookie
        const checkoutUrl = handleCheckoutProcess();

        if (checkoutUrl) {
            // Set up a specific observer for dynamic payment buttons
            const dynamicButtonObserver = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.addedNodes.length) {
                        mutation.addedNodes.forEach((node) => {
                            if (node.nodeType === 1) {
                                // Element node
                                // Check the added node itself
                                if (
                                    node.matches &&
                                    node.matches(CONFIG.DYNAMIC_PAYMENT_SELECTOR)
                                ) {
                                    setupDynamicButton(node, checkoutUrl);
                                }

                                // Check children of the added node
                                const dynamicButtons = node.querySelectorAll(
                                    CONFIG.DYNAMIC_PAYMENT_SELECTOR
                                );
                                dynamicButtons.forEach((button) => {
                                    setupDynamicButton(button, checkoutUrl);
                                });
                            }
                        });
                    }
                });
            });

            // Start observing with the dynamic button observer
            dynamicButtonObserver.observe(document.body, {
                childList: true,
                subtree: true,
            });

            // Handle any existing dynamic payment buttons
            const existingButtons = document.querySelectorAll(
                CONFIG.DYNAMIC_PAYMENT_SELECTOR
            );
            existingButtons.forEach((button) => {
                setupDynamicButton(button, checkoutUrl);
            });
        }

        // Setup observer for cart changes
        const cartObserver = new MutationObserver(() => {
            handleCheckoutProcess();
        });

        // Observe cart-specific elements instead of the entire body
        const cartContainer = document.querySelector(
            '[data-cart-container], [data-section="cart"], .cart, #cart'
        );
        if (cartContainer) {
            cartObserver.observe(cartContainer, {
                childList: true,
                subtree: true,
                attributes: true,
            });
        }

        //console.log("CheckyPro: Fully initialized \u2713");
    }

    // Initialize the checkout redirection
    function initialize() {
        //console.log("CheckyPro: Initializing...");

        // Try to get cart token immediately
        const cartDetails = getCartDetails();

        if (cartDetails?.token) {
            // Token available, complete initialization immediately
            //console.log("CheckyPro: Cart token found immediately");
            completeInitialization();
        } else {
            // No token yet, start polling
            //console.log("CheckyPro: No cart token found, starting polling...");
            startTokenPolling();

            // Also set up observers to catch when token becomes available
            const cartObserver = new MutationObserver(() => {
                if (!state.isInitialized) {
                    const details = getCartDetails();
                    if (details?.token) {
                        if (state.tokenCheckInterval) {
                            clearInterval(state.tokenCheckInterval);
                            state.tokenCheckInterval = null;
                        }
                        completeInitialization();
                    }
                } else {
                    handleCheckoutProcess();
                }
            });

            // Observe cart-specific elements
            const cartContainer = document.querySelector(
                '[data-cart-container], [data-section="cart"], .cart, #cart'
            );
            if (cartContainer) {
                cartObserver.observe(cartContainer, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                });
            }
        }
    }

    // ==============================================================
    // AGGRESSIVE EARLY CLICK INTERCEPTION (Capturing Phase)
    // ==============================================================
    // This runs BEFORE any theme JavaScript can handle the click
    //console.log("CheckyPro: Setting up global click interceptor...");

    // Helper function to check if element is a buy now button
    function isBuyNowButton(element) {
        if (!element || !element.matches) return false;

        // Check if element itself is a buy now button
        if (element.matches('shopify-buy-it-now-button button') ||
            element.closest('shopify-buy-it-now-button')) {
            return true;
        }

        // Check if it's a dynamic payment button (which includes buy now)
        if (element.matches(CONFIG.DYNAMIC_PAYMENT_SELECTOR) ||
            element.closest(CONFIG.DYNAMIC_PAYMENT_SELECTOR)) {
            // Check if it's specifically a buy now button
            const buyNowContainer = element.closest('shopify-buy-it-now-button');
            if (buyNowContainer) {
                return true;
            }
        }

        return false;
    }

    function isCheckoutButton(element) {
        if (!element || !element.matches) return false;

        // Check if element itself matches
        if (element.matches(CONFIG.CHECKOUT_SELECTOR)) {
            //console.log("[CheckyPro isCheckoutButton] Element itself matches selector");
            return true;
        }

        // Check if any parent element matches (for clicks on child elements like icons/text)
        const closestCheckoutElement = element.closest(CONFIG.CHECKOUT_SELECTOR);
        if (closestCheckoutElement) {
            //console.log("[CheckyPro isCheckoutButton] Parent element matches selector:", closestCheckoutElement);
            return true;
        }

        // Additional check for direct checkout links
        const parentLink = element.closest('a[href*="/checkout"]');
        if (parentLink) {
            //console.log("[CheckyPro isCheckoutButton] Found parent checkout link:", parentLink.href);
            return true;
        }

        return false;
    }

    // Track processed events to prevent duplicate handling from multiple event types
    const processedEvents = new WeakSet();
    let lastProcessedTime = 0;
    let lastProcessedTarget = null;
    const DEBOUNCE_MS = 500; // Prevent same button from being processed twice within 500ms

    function handleGlobalClick(e) {
        const target = e.target;
        const now = Date.now();

        // Prevent duplicate processing: same event object or same target within debounce period
        if (processedEvents.has(e) ||
            (target === lastProcessedTarget && (now - lastProcessedTime) < DEBOUNCE_MS)) {
            return;
        }

        // Mark this event as processed
        processedEvents.add(e);
        lastProcessedTime = now;
        lastProcessedTarget = target;

        //console.log("[CheckyPro Click Interceptor] Click detected on:", {
        //     tagName: target.tagName,
        //     className: target.className,
        //     id: target.id,
        //     href: target.href,
        //     name: target.name,
        //     type: target.type,
        //     text: target.textContent?.trim().substring(0, 50)
        // });

        // Check if this is a buy now button first (needs special handling)
        if (isBuyNowButton(target)) {
            // IMMEDIATELY prevent default behavior
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            // Check if already processing
            if (isProcessingBuyNow) {
                return false;
            }

            // Find the actual button element (might be a child element that was clicked)
            let button = target;
            if (target.closest('shopify-buy-it-now-button')) {
                const buyNowContainer = target.closest('shopify-buy-it-now-button');
                button = buyNowContainer.querySelector('button:not([aria-disabled="true"])') || target;
            } else if (!target.matches('button')) {
                button = target.closest('button') || target;
            }

            // Use addToCartAndRedirect which handles: clear cart -> add product -> redirect
            addToCartAndRedirect(button).catch((error) => {
                console.error("[CheckyPro Click Interceptor] Failed to process buy now:", error);
            });

            return false;
        }

        // Check if this is a regular checkout button (cart already has items)
        if (isCheckoutButton(target)) {
            //console.log("[CheckyPro Click Interceptor] \u2713 CHECKOUT BUTTON DETECTED!");
            //console.log("[CheckyPro Click Interceptor] Preventing default and redirecting...");

            // IMMEDIATELY prevent default behavior
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            // Find the actual button element (might be a child element that was clicked)
            let button = target;
            if (!target.matches('button') && !target.matches('a')) {
                button = target.closest('button') || target.closest('a[href*="/checkout"]') || target;
            }

            // Disable the button immediately to prevent multiple clicks
            disableCheckoutButton(button);

            // Get cart details and redirect
            const cartDetails = getCartDetails();
            //console.log("[CheckyPro Click Interceptor] Cart details:", cartDetails);

            if (cartDetails && cartDetails.token) {
                const checkoutUrl = constructCheckoutUrl(cartDetails);
                //console.log("[CheckyPro Click Interceptor] Redirecting to:", checkoutUrl);
                navigateToChecky(checkoutUrl);
            } else {
                console.error("[CheckyPro Click Interceptor] No cart token available");
                resetCheckoutButtonState(button);
                alert("Please add items to your cart before checking out.");
            }

            return false;
        } else {
            console.log("[CheckyPro Click Interceptor] Not a checkout button, ignoring");
        }
    }

    // Add the global interceptor in CAPTURING PHASE (runs first!)
    document.addEventListener("click", handleGlobalClick, true); // true = capturing phase
    document.addEventListener("mousedown", handleGlobalClick, true);
    document.addEventListener("touchstart", handleGlobalClick, true);

    //console.log("CheckyPro: Global click interceptor installed \u2713");

    initialize();

    // Handle UpCart checkout button override
    function overrideUpCartCheckoutButton(cart) {
        const root = window.upcartDocumentOrShadowRoot;
        if (!root) return;

        const button = root.querySelector('.upcart-checkout-button');
        if (!button) return;

        // Avoid re-wiring the same instance repeatedly
        if (button.dataset.checkyProCustomized === 'true') return;
        button.dataset.checkyProCustomized = 'true';

        const newBtn = button.cloneNode(true);
        newBtn.classList.add('checkypro-custom-checkout-button');

        newBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            // Disable the button immediately to prevent multiple clicks
            disableCheckoutButton(newBtn);

            // Close cart if helper exists
            if (window.upcartCloseCart) {
                window.upcartCloseCart();
            }

            // Get the latest cart details and redirect using CheckyPro logic
            const cartDetails = getCartDetails();
            if (cartDetails && cartDetails.token) {
                const checkoutUrl = constructCheckoutUrl(cartDetails);
                //console.log("UpCart: Redirecting to CheckyPro checkout:", checkoutUrl);
                navigateToChecky(checkoutUrl);
            } else {
                console.error("UpCart: Failed to get cart details for checkout");
                resetCheckoutButtonState(newBtn);
                alert("Please add items to your cart before checking out.");
            }
        });

        button.replaceWith(newBtn);
    }

    // Listen for UpCart events
    window.addEventListener(
        'aftersell-upcart:public-events:cart-loaded',
        (event) => {
            const cart = event.detail?.cart || event.detail || null;
            overrideUpCartCheckoutButton(cart);
        }
    );

    window.addEventListener(
        'aftersell-upcart:public-events:cart-updated',
        (event) => {
            const cart = event.detail?.cart || event.detail || null;
            overrideUpCartCheckoutButton(cart);
        }
    );

    // Expose cart validation functions globally for external use
    window.CheckyPro = {
        validateCartSession: validateCartSession,
        checkCartCookieDeletion: checkCartCookieDeletion,
        parseCartCookie: parseCartCookie,
        getCartDetails: getCartDetails
    };

    function restoreAfterBfcache() {
        isProcessingBuyNow = false;
        resetAllCheckoutButtons();
        document.body && document.body.classList.add('checkypro-ready');
        state.lastCheckoutUrl = null;
        handleCheckoutProcess();
    }

    window.addEventListener('pageshow', function (event) {
        if (event.persisted) {
            restoreAfterBfcache();
        }
    });

    window.addEventListener('pagehide', function (event) {
        if (event.persisted) {
            resetAllCheckoutButtons();
            isProcessingBuyNow = false;
        }
    });

    trackSession();
})();